export default "__VITE_ASSET__89XK8Qt6__"